import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, Skeleton } from '@mui/material';
import {
    CustomButton,
    HighchartBarChart,
    USACountryChart,
} from '../../../shared';
import {
    PRACTICE_LOCATION_CHART_OPTIONS,
    LOCATION_CHART_OPTIONS,
} from './constants';
import { useDispatch, useSelector } from 'react-redux';
import { getTopStatesByIndividuals, getRegionCount } from '../../../../redux/thunks/physicanTargetListAnalysisThunk';
import { TEPMETKO_COMPANY_ID, BAVENCIO_COMPANY_ID } from '../../../../constants';

const PracticeLocation = () => {
    const dispatch = useDispatch();
    const { company } = useSelector((state) => state.company);
    const { topStatesByIndividuals } = useSelector(
        (state) => state.physicianTargetListAnalysis
    );
    const {
        mapSeries,
        chartSeries,
        isLoading,
        overAllIndividuals,
        top15Total,
    } = topStatesByIndividuals;
    const isHideSpecialtyGraph = (company?.id === TEPMETKO_COMPANY_ID || company?.id === BAVENCIO_COMPANY_ID );

    useEffect(() => {
        if (company.id) {
            dispatch(getTopStatesByIndividuals({ companyId: company.id }));
            dispatch(getRegionCount({ companyId: company.id }));
        }
    }, [company.id]);

    return (
        <Box className="box-sizing-border-box padding-24px">
            <Box className="padding-tb-24-rl-0 border-bottom-gray">
                <Box className="flex-row">
                    <Box>
                        <Typography className="text-lg-semi-bold gray-900">
                        {isHideSpecialtyGraph ? 'B.' : 'C.'} Distribution by Location
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Grid container className="flex-row-center pt-20px">
                <Grid item lg={7} xl={8}>
                    {/* Location Chart */}
                    {isLoading ? (
                        <Skeleton
                            variant="rectangular"
                            width={'90%'}
                            height={400}
                        />
                    ) : (
                        <USACountryChart
                            chartOptions={LOCATION_CHART_OPTIONS}
                            mapSeries={mapSeries}
                        />
                    )}
                </Grid>

                <Grid item lg={5} xl={4}>
                    {/* Location Info */}
                    <Box className="flex-column gap-4">
                        <Typography className="text-lg-semi-bold gray-900">
                            Top {chartSeries?.length > 15 ? "15" : chartSeries?.length === 0 ? "" : chartSeries?.length} States by HCPs
                        </Typography>
                    </Box>
                    <Box className="pt-24px">
                        {isLoading ? (
                            <Skeleton
                                variant="rectangular"
                                width={'100%'}
                                height={250}
                            />
                        ) : (
                            <HighchartBarChart
                                chartOptions={{
                                    ...PRACTICE_LOCATION_CHART_OPTIONS,
                                    chart: {
                                        ...PRACTICE_LOCATION_CHART_OPTIONS.chart,
                                    },
                                }}
                                seriesData={chartSeries?.slice(0, 15)}
                                seriesName="Physcian Target List Top States by individuals"
                            />
                        )}
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default PracticeLocation;
